module.exports = __webpack_public_path__ + "img/logo-ecart.7b6edf70.png";